'use strict';

let AttributeSetter = require('./attribute_setter').AttributeSetter;

class AuthorizationAdjustment extends AttributeSetter {}

module.exports = {AuthorizationAdjustment: AuthorizationAdjustment};
